import { SET_DSR_BRANDING } from '../../actions/dsr-actions-types'

const INITIAL_STATE_SET_DSR_BRANDING = { results: '' }

export function setDsrBrandingReducer(state = INITIAL_STATE_SET_DSR_BRANDING, action) {
    switch (action.type) {
        case SET_DSR_BRANDING:
            return { results: action.payload }
        default:
            return state;
    }
}